type PiiLike = {
  identityInformation?: {
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
  } | null;
  contactInformation?: {
    email?: string | null;
  } | null;
} | null | undefined;

export type NameFallback = 'email' | 'dash' | 'none';

/**
 * Formats a display name from PII data.
 *
 * @param pii - PII object with identity/contact information
 * @param fallback - What to return if no name available:
 *   - 'email': email prefix (before @)
 *   - 'dash': returns '-'
 *   - 'none': returns empty string
 */
export function formatDisplayName(
  pii: PiiLike,
  fallback: NameFallback = 'dash'
): string {
  const fullName = [
    pii?.identityInformation?.firstName,
    pii?.identityInformation?.middleName,
    pii?.identityInformation?.lastName,
  ]
    .filter(Boolean)
    .join(' ');

  if (fullName) return fullName;

  switch (fallback) {
    case 'email':
      return pii?.contactInformation?.email?.split('@')[0] || '-';
    case 'dash':
      return '-';
    case 'none':
      return '';
  }
}
